const INITIAL_STATE = {
  report: {},
  errors: {},
  data: {}
        
}
    
const GetServiceEODReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_EOD_REPORT_SUCCESSFULLY':
    return { ...INITIAL_STATE, report: action.data }
  case 'GET_SERVICE_EOD_REPORT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'RESCHEDULE_MULTIPLE_SERVICES_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data}
  case 'RESCHEDULE_MULTIPLE_SERVICES_FAILED':
    return { ...INITIAL_STATE, errors: action.data}
  default:
    return { ...state }
  }
};
        
export default GetServiceEODReport;